import { COMBINATION_CONFIG } from './data/getCombinationsReport';
import { round2 } from '../../lib/format';

export function HeatmapTooltip({ data }) {
  const activeProp = data[3];
  const combination = data[4];

  const propertyValues = getCombinationPropertysFormatted(
    combination,
    activeProp,
  );
  const title = getCombinationTitle(combination);
  const possessions = round2(combination.possessions);

  return `
    <div class="chart-tooltip">
      <table>
        <thead><tr><th colSpan="2">${title}</th></tr></thead>
        <tbody>
          ${propertyValues}
          <tr>
            <th>Possessions:</th>
            <td>${possessions}</td>
          </tr>
        </tbody>
      </table>
    </div>
  `;
}

function getCombinationTitle(combination) {
  const player1Id = `${combination.player1.jersey} ${combination.player1.name}`;
  const player2Id = `${combination.player2.jersey} ${combination.player2.name}`;

  return combination.player1.jersey === combination.player2.jersey
    ? player1Id
    : `${player1Id} - ${player2Id}`;
}

function getCombinationPropertysFormatted(combination, activeProp) {
  return Object.keys(COMBINATION_CONFIG)
    .map(property => {
      const name = COMBINATION_CONFIG[property].name;
      const isActive = property === activeProp;
      const className = isActive ? 'active' : '';
      const value = round2(combination[property]);

      return `
      <tr class="${className}">
        <th>${name}:</th>
        <td>${value}</td>
      </tr>
      `;
    })
    .join('');
}
